"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _componentDataParser = _interopRequireDefault(require("../js/component-data-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getTagListForElementOrItem = function getTagListForElementOrItem(elementOrItem) {
  var dataTag = elementOrItem.getAttribute('data-tag');

  if (dataTag) {
    return dataTag.split(' ');
  }

  return [];
};
/**
   *
   * @param {HTMLElement} item
   * @returns {Object}
   */


var getComponentItem = function getComponentItem(item) {
  var output = {};
  output.classes = _toConsumableArray(item.classList);
  output.html = _componentDataParser["default"].getComponentHtml(item);
  output.type = 'text';

  if (item.classList.contains('element__item__link') || item.classList.contains('pre-element__item__link') || item.classList.contains('post-element__item__link')) {
    output.link = _componentDataParser["default"].getComponentLink(item.querySelector('a'));
    output.type = 'link';
  }

  if (item.classList.contains('element__item__image') || item.classList.contains('pre-element__item__image') || item.classList.contains('post-element__item__image')) {
    output.image = _componentDataParser["default"].getComponentImage(item.querySelector('img'));
    output.type = 'image';
  }

  if (item.classList.contains('element__item__video') || item.classList.contains('pre-element__item__video') || item.classList.contains('post-element__item__video')) {
    output.video = _componentDataParser["default"].getComponentIframe(item.querySelector('iframe'));
    output.type = 'video';
  }

  output.tag = item.getAttribute('data-tag');
  output.tags = getTagListForElementOrItem(item);
  return output;
};
/**
   *
   * @param {Array.<HTMLElement>} items
   * @returns {Array.<Object>}
   */


var getComponentItemList = function getComponentItemList(items) {
  return items ? items.map(function (item) {
    return getComponentItem(item);
  }) : [];
};

var getComponentItemListTagged = function getComponentItemListTagged(items) {
  var taggedItems = {};

  if (items) {
    items.forEach(function (item) {
      var parsedItem = getComponentItem(item);
      var tags = getTagListForElementOrItem(item);
      tags.forEach(function (tag) {
        if (taggedItems[tag]) {
          if (taggedItems[tag] instanceof Array) {
            taggedItems[tag].push(parsedItem);
          } else {
            taggedItems[tag] = [parsedItem];
          }
        } else {
          taggedItems[tag] = parsedItem;
        }
      });
    });
  }

  return taggedItems;
};

var _default = [{
  name: 'numCols',
  parser: function parser(component) {
    return component.getAttribute('data-num-cols');
  }
}, {
  name: 'preElementItems',
  elements: '.pre-element__item',
  parser: function parser(elementList) {
    return getComponentItemList(elementList);
  }
}, {
  name: 'preElementTaggedItems',
  elements: '.pre-element__item',
  parser: function parser(elementList) {
    return getComponentItemListTagged(elementList);
  }
}, {
  name: 'preElementTags',
  element: '.pre-element',
  parser: function parser(element) {
    return getTagListForElementOrItem(element);
  }
}, {
  name: 'elements',
  elements: '.element',
  parser: function parser(elements) {
    var output = [];
    elements.forEach(function (element) {
      output.push({
        items: getComponentItemList(Array.from(element.querySelectorAll('.element__item'))),
        taggedItems: getComponentItemListTagged(Array.from(element.querySelectorAll('.element__item'))),
        tags: getTagListForElementOrItem(element)
      });
    });
    return output;
  }
}, {
  name: 'taggedElements',
  elements: '.element',
  parser: function parser(elements) {
    var output = {};
    elements.forEach(function (element) {
      var tagList = getTagListForElementOrItem(element);
      var parsedElement = {
        items: getComponentItemList(Array.from(element.querySelectorAll('.element__item'))),
        taggedItems: getComponentItemListTagged(Array.from(element.querySelectorAll('.element__item'))),
        tags: getTagListForElementOrItem(element)
      };
      tagList.forEach(function (tag) {
        if (output[tag]) {
          if (output[tag] instanceof Array) {
            output[tag].push(parsedElement);
          } else {
            output[tag] = [parsedElement];
          }
        }

        output[tag] = parsedElement;
      });
    });
    return output;
  }
}, {
  name: 'postElementItems',
  elements: '.post-element__item',
  parser: function parser(elementList) {
    return getComponentItemList(elementList);
  }
}, {
  name: 'postElementTaggedItems',
  elements: '.post-element__item',
  parser: function parser(elementList) {
    return getComponentItemListTagged(elementList);
  }
}, {
  name: 'postElementTags',
  element: '.post-element',
  parser: function parser(element) {
    return getTagListForElementOrItem(element);
  }
}];
exports["default"] = _default;